import { closeText } from 'owa-locstrings/lib/strings/closetext.locstring.json';
import loc from 'owa-localize';
import * as React from 'react';

import { ControlIcons } from 'owa-control-icons';
import { IButtonProps, IconButton } from '@fluentui/react/lib/Button';

const styles = require('./CustomRecurrenceModal.scss');
let classNames = require('classnames/bind').bind(styles);

export interface CustomRecurrenceModalHeaderProps {
    onClose: () => void;
    text: string;
}

const CustomRecurrenceModalHeader = (props: CustomRecurrenceModalHeaderProps) => {
    let closeButtonProps: IButtonProps = {
        onClick: props.onClose,
        iconProps: {
            iconName: ControlIcons.Cancel,
            styles: {
                root: {
                    fontSize: '15px',
                },
            },
        },
        title: loc(closeText),
        ariaLabel: loc(closeText),
        className: styles.closeButton,
    };

    return (
        <div className={classNames(styles.customRecurrenceHeaderContainer)}>
            <span className={classNames(styles.customRecurrenceHeaderText)}>{props.text}</span>
            <IconButton {...closeButtonProps} key={closeButtonProps.title} />
        </div>
    );
};

export default CustomRecurrenceModalHeader;
